import { isSalesTeamMember } from './salesTeamFilter';

export function getAssignmentUsers(users, assignedUid = '') {
    return users.filter(user =>
        user.role !== 'disabled' ||
        (assignedUid && (user.uid || user.userId || user.id) === assignedUid)
    );
}

export function canAssignOpportunity(user) {
    return Boolean(user && user.role !== 'disabled' && isSalesTeamMember(user));
}

export function getOpportunityAssignmentUsers(users, assignedUid = '') {
    return users.filter(user =>
        canAssignOpportunity(user) ||
        (assignedUid && (user.uid || user.userId || user.id) === assignedUid)
    );
}
